<div class="table-container">
  <table>
    <thead>
      <tr class="table-head">
        <th *ngFor="let header of headers">{{ header }}</th>
      </tr>
    </thead>
  
    <ng-container *ngIf="!this.fetchingData">
      <tr class="data-row" *ngFor="let row of data">
        <td (click)="action(row[0])" *ngFor="let cell of row.slice(1, 10)">
          {{ cell }}
        </td>
        <div *ngIf="canDelete && data.length > 0"
          (click)="remove_(row[0])" 
          class="icon-delete"></div>

          <!-- <div *ngIf="canResend && data.length > 0"
            (click)="action(row[0])" 
            class="icon-refresh"></div> -->

      </tr>
    </ng-container>
  
    <ng-container *ngIf="this.fetchingData">
      <tr *ngFor="let row of [1, 2, 3]">
        <td *ngFor="let cell of headers">
          <ngx-skeleton-loader></ngx-skeleton-loader>
        </td>
      </tr>
    </ng-container>
  </table>
</div>
